import EndDayStockCount from "../layouts/ecommerce/EndDayStockCount";
import StockAdjustment from "../layouts/ecommerce/StockAdjustment";
import KitchenDisplaySystem from "../layouts/ecommerce/KDS";
import ThirdPartyLogistics from "../layouts/ecommerce/ThirdPartyLogistics";
import ExpensesListing from "../layouts/ecommerce/expenses";
import Drawer from "../layouts/ecommerce/product/Drawer";
import { CompleteOrder } from "../layouts/ecommerce/product/all-products/CompleteOrder";
import HoldOrderPage from "../layouts/ecommerce/product/all-products/HoldOrderPage";
import Invoice from "../layouts/ecommerce/product/all-products/Invoice";
import LoginPage from "../layouts/ecommerce/product/all-products/LoginPage";
import Menu from "../layouts/ecommerce/product/all-products/Menu";
import OrdersTable from "../layouts/ecommerce/product/all-products/OrdersTable";
import { ProductsPage } from "../layouts/ecommerce/product/all-products/ProductsPage";
import { Points } from "../layouts/ecommerce/product/all-products/Points";
import { CompleteCreditOrder } from "../layouts/ecommerce/product/all-products/completeCreditOrder";
import LocationModalV2 from "../layouts/ecommerce/product/all-products/components/LocationModal/indexV2";
import { AddProducts } from "../layouts/ecommerce/product/all-products/components/add-products";
import NotFound from "../layouts/ecommerce/product/all-products/components/errorModal";
import { MobCoupons } from "../layouts/ecommerce/product/all-products/components/mobCoupons";
import { Offers } from "../layouts/ecommerce/product/all-products/components/offers/offers";
import Returns from "../layouts/ecommerce/Returns/Returns";
import { ReturnsCreation } from "../layouts/ecommerce/Returns/components/ReturnsCreation";
import OperationsMenuPage from "../layouts/ecommerce/product/all-products/OperationsMenuPage";
import { Print } from "../layouts/ecommerce/product/all-products/print";
import { TestLabel } from "../layouts/ecommerce/product/all-products/print/testlabel";
import { TestPrint } from "../layouts/ecommerce/product/all-products/print/testprint";
import { AuthenticationV2 } from "../layouts/ecommerce/product/sessionPage/components/Authentication/indexV2";
import { ClosingV2 } from "../layouts/ecommerce/product/sessionPage/components/Closing/indexV2";
import DayClosing from "../layouts/ecommerce/product/sessionPage/components/DayClosing";
import { ManagerAuthV2 } from "../layouts/ecommerce/product/sessionPage/components/ManagerAuth/indexV2";
import { Opening } from "../layouts/ecommerce/product/sessionPage/components/Opening";
import { OpeningV2 } from "../layouts/ecommerce/product/sessionPage/components/Opening/indexV2";
import { SessionListingV2 } from "../layouts/ecommerce/product/sessionPage/components/SessionListing/indexV2";
import DenominationV2 from "../layouts/ecommerce/product/sessionPage/components/denomination/denominationV2";
import { StartDayV2 } from "../layouts/ecommerce/product/sessionPage/components/startDay.js/indexV2";
import SessionPageV2 from "../layouts/ecommerce/product/sessionPageV2/SessionPageV2";
import Settings from "../layouts/ecommerce/product/settings";
import { Account } from "../layouts/ecommerce/product/settings/components/Account";
import { CreateMenu } from "../layouts/ecommerce/product/settings/components/CreateMenu";
import { CreateMenuForm } from "../layouts/ecommerce/product/settings/components/CreateMenuForm/CreateMenuForm";
import { DisplayModeSettings } from "../layouts/ecommerce/product/settings/components/DisplaySettings";
import { KeyboardShortcuts } from "../layouts/ecommerce/product/settings/components/KeyboardShortcut";
import { CreateCategory } from "../layouts/ecommerce/product/settings/components/MenuCategory/CreateCategory";
import { MenuCategoryTable } from "../layouts/ecommerce/product/settings/components/MenuCategory/MenuCategoryTable";
import { Peripherals } from "../layouts/ecommerce/product/settings/components/Peripherals";
import { AppDetails } from "../layouts/ecommerce/product/settings/components/Peripherals/AppDetails";
import { PrinterConfigurationSettings } from "../layouts/ecommerce/product/settings/components/PrinterConfiguration";
import PrinterAgent from "../layouts/ecommerce/product/settings/components/PrinterAgent";
import RestaurantReservationUI from "../layouts/ecommerce/table-layout";
import TableOrdering from "../layouts/ecommerce/table-ordering";
import CustomersPage from "../layouts/ecommerce/customers";
import KitchenOSDashboard from "../layouts/ecommerce/Kitchen-OS";
import PrepRequestKitchenOS from "../layouts/ecommerce/Kitchen-OS/components/prepRequest-kitchenOS";
import InventoryCompute from "../layouts/ecommerce/Kitchen-OS/components/inventory-compute";
import SettingsKitchenOS from "../layouts/ecommerce/Kitchen-OS/components/settings-kitchenOS";
import FulfillmentKitchenOS from "../layouts/ecommerce/Kitchen-OS/components/fulfillment-kitchenOS";
import HistoryKitchenOS from "../layouts/ecommerce/Kitchen-OS/components/history-kitchenOS";
import ReportsAndAnalysisKitchenOS from "../layouts/ecommerce/Kitchen-OS/components/reportsAndAnalysis";
import ChangeTheme from "../layouts/ecommerce/product/settings/components/ChangeTheme";
import QuickTroubleshoot from "../layouts/ecommerce/product/settings/components/QuickTroubleshoot";
import GroceryCart from "../layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/GroceryCart";
import OrdersPage from "../layouts/ecommerce/ordersPage/OrdersPage";
import { ProfileEditPage } from "../layouts/ecommerce/product/settings/components/ProfileEditPage/ProfileEditPage";
import CustomerTableV2 from "../layouts/ecommerce/product/all-products/CustomerTableV2";
import CustomerV2Preview from "../layouts/ecommerce/product/all-products/CustomerV2Preview/CustomerV2Preview";
import AccessMode from "../layouts/ecommerce/product/all-products/components/AccessMode/AccessMode";
import OrdersDetailsV2 from "../layouts/ecommerce/product/OrdersV2/OrdersDetailsV2";
import CustomerCreditSummary from "../layouts/ecommerce/product/CustomerCreditSummary/CustomerCreditSummary";
import ReturnsDetails from "../layouts/ecommerce/Returns/ReturnsDetails";
import { DualScreenSettings } from "../layouts/ecommerce/product/settings/components/DualScreen";
import DualScreenDisplay from "../layouts/ecommerce/product/settings/components/DualScreenDisplay";
import RolesPermissions from "../layouts/ecommerce/product/settings/components/RolesPermissions";
import AccountSubscription from "../layouts/ecommerce/product/settings/components/AccountSubscription";
import AppsIntegrations from "../layouts/ecommerce/product/settings/components/AppsIntegrations";
import AppDetail from "../layouts/ecommerce/product/settings/components/AppsIntegrations/AppDetail";
import Dashboard from "../layouts/ecommerce/product/all-products/Dashbaord/Dashboard";
import StaffManagementPage from "../layouts/ecommerce/product/all-products/StaffManagementPage";
import AttendanceCapturePage from "../layouts/ecommerce/product/all-products/AttendanceCapturePage";
import EmployeeEnrollmentPage from "../layouts/ecommerce/product/all-products/EmployeeEnrollmentPage";
import AttendanceHistoryPage from "../layouts/ecommerce/product/all-products/AttendanceHistoryPage";

export const pathElements = [
  { path: "/dual-screen", element: <DualScreenDisplay /> },
  { path: "/settings/dual-screen", element: <DualScreenSettings /> },
  { path: "*", element: <NotFound /> },
  { path: "/", element: <LoginPage />, exact: true },
  { path: "/products/location", element: <LocationModalV2 /> },
  { path: "/products/access-mode", element: <AccessMode /> },
  { path: "/products/all-products/add-products", element: <AddProducts /> },
  { path: "/products/invoicepage", element: <Invoice /> },
  { path: "/products/customertable", element: <CustomerTableV2 /> },
  // b2b customer preview end point
  { path: "/products/customertable/:customerType/:retailId", element: <CustomerV2Preview /> },
  //pos customer preview end point
  { path: "/products/customertable/:customerType/:uidx", element: <CustomerV2Preview /> },
  // app customer preview end point
  {
    path: "/products/customertable/:customerType/:phoneNumber/:customerId",
    element: <CustomerV2Preview />,
  },

  { path: "/products/orderstable", element: <OrdersTable /> },
  { path: "/products/order/:id", element: <OrdersDetailsV2 /> },

  {
    path: `/products/order/customer-credit-summary/:accountNoteId`,
    element: <CustomerCreditSummary />,
  },
  { path: "/products/holdorderpage", element: <HoldOrderPage /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/products/operations-menu", element: <OperationsMenuPage /> },
  { path: "/products/staff-management", element: <StaffManagementPage /> },
  { path: "/products/staff-management/capture", element: <AttendanceCapturePage /> },
  { path: "/products/staff-management/enrollment", element: <EmployeeEnrollmentPage /> },
  { path: "/products/staff-management/history", element: <AttendanceHistoryPage /> },
  { path: "/orders", element: <OrdersPage /> },
  { path: "/products/coupons", element: <MobCoupons /> },
  { path: "/products/points", element: <Points /> },
  { path: "/restaurant/cart", element: <ProductsPage /> },
  // { path: "/session-page/start-day", element: <StartDay /> },
  { path: "/session-page/start-day", element: <StartDayV2 /> },
  { path: "/session-page/opening", element: <OpeningV2 /> },
  { path: "/session-page/authentication", element: <AuthenticationV2 /> },
  { path: "/session-page/manager-auth", element: <ManagerAuthV2 /> },
  { path: "/session-page/closing", element: <ClosingV2 /> },
  { path: "/session-page/session-listing", element: <SessionListingV2 /> },
  { path: "/session-page/new-session-page", element: <SessionPageV2 /> },
  { path: "/session-page/day/closing", element: <DayClosing /> },
  { path: "/session-page/day/closing/end", element: <EndDayStockCount /> },
  { path: "/settings", element: <Settings /> },
  { path: "/settings/accounts", element: <Account /> },
  { path: "/settings/roles-permissions", element: <RolesPermissions /> },
  { path: "/settings/account-subscription", element: <AccountSubscription /> },
  { path: "/settings/apps-integrations", element: <AppsIntegrations /> },
  { path: "/settings/app-detail", element: <AppDetail /> },
  { path: "/settings/themes", element: <ChangeTheme /> },
  { path: "/settings/peripherals", element: <Peripherals /> },
  { path: "/settings/keyboard-shortcuts", element: <KeyboardShortcuts /> },
  { path: "/settings/drawer", element: <Drawer /> },
  { path: "/settings/peripherals/:app", element: <AppDetails /> },
  { path: "/print", element: <Print /> },
  { path: "/order-completed", element: <CompleteOrder /> },
  { path: "/credit-order-completed", element: <CompleteCreditOrder /> },
  { path: "/testprint", element: <TestPrint /> },
  { path: "/settings/network/configuration", element: <QuickTroubleshoot /> },
  { path: "/settings/trouble-shoot", element: <QuickTroubleshoot /> },
  { path: "/settings/printer-agent", element: <PrinterAgent /> },
  { path: "/testlabel", element: <TestLabel /> },
  { path: "session-page/denominations", element: <DenominationV2 /> },
  { path: "/menu", element: <Menu /> },
  { path: "/products/offers", element: <Offers /> },
  { path: "/grocery/cart", element: <GroceryCart /> },
  { path: "/settings/display-settings", element: <DisplayModeSettings /> },
  { path: "/settings/printer-configuration", element: <PrinterConfigurationSettings /> },
  { path: "/returns", element: <Returns /> },
  { path: "/returns/:id", element: <ReturnsCreation /> },
  { path: "/returns/details", element: <ReturnsDetails /> },
  { path: "/settings/create-menu", element: <CreateMenu /> },
  { path: "/settings/menu-category-table", element: <MenuCategoryTable /> },
  { path: "/settings/create-category", element: <CreateCategory /> },
  { path: "/settings/create-menu-form", element: <CreateMenuForm /> },
  { path: "/products/table-layout", element: <RestaurantReservationUI /> },
  { path: "/products/table-ordering", element: <TableOrdering /> },
  { path: "/products/expenses", element: <ExpensesListing /> },
  { path: "/products/inventory", element: <StockAdjustment /> },
  { path: "/products/kitchen-display", element: <KitchenDisplaySystem /> },
  { path: "/products/customers", element: <CustomersPage /> },
  { path: "/products/kitchenos/dashboard", element: <KitchenOSDashboard /> },
  { path: "/products/kitchenos/prep-requests", element: <PrepRequestKitchenOS /> },
  { path: "/products/kitchenos/inventory/compute", element: <InventoryCompute /> },
  { path: "/products/kitchenos/settings", element: <SettingsKitchenOS /> },
  { path: "/products/kitchenos/fulfilment", element: <FulfillmentKitchenOS /> },
  { path: "/products/kitchenos/history", element: <HistoryKitchenOS /> },
  { path: "/products/kitchenos/reports", element: <ReportsAndAnalysisKitchenOS /> },
  { path: "/logistics", element: <ThirdPartyLogistics /> },
  { path: "/profile/edit", element: <ProfileEditPage /> },
];
